export const timekeepingSettingEN = {
    "timeKeeping-setting": {
        "timeKeeping-setting": {
            "timeKeeping-setting": "Set timekeeping",
            "general-settings-header": "GENERAL SETTINGS",
            "general-settings": {
                "time-attendance-code": "Time attendance code taken",
                "time-attendance-code-detail": "The timekeeping code can be obtained by the personnel code or the independent code, it is best to get it according to the personnel code, in this case you need to install more information below.",
                "time-attendance-code-from-handmade": "Enter the timekeeping code",
                "time-attendance-code-from-auto": "Get by personnel code",
                "general-settings-auto": {
                    "take-it": "Retrieve the last n digits of the personnel code",
                    "take-it-detail": "Due to the fact that the timekeeping code only allows entering numeric characters, sometimes the timekeeping code is taken by the last numbers of the personnel code (because the personnel code may contain alphanumeric characters).",
                    "take-it-form": "Enter the last number of the personnel code"
                },
                "time-start-time-keeping": "Starting date of monthly calculation",
                "time-start-time-keeping-detail": "Is the start date of the work cycle, taken according to the calendar month",
                "exempted-from-closing": "Free time is allowed to be waived",
                "exempted-from-closing-detail": "For example: In this stage, you choose 15 minutes, assuming the employee works 2 shifts 10 minutes apart, then that employee does not need to close the previous shift and enter the next shift, the system will automatically understand that the employee works in succession.",
                "show-on-timesheet": "Show on timesheet",
                "show-on-timesheet-detail": "Depending on the purpose you want to display on the timesheet, select the setting according to the purpose you want to display on the timesheet",
                "show-by-job": "Show by job",
                "show-by": "Shift work + overtime",
                "show-by1": "Work by shift",
                "show-by-hour": "Show by hour",
                "code-api-time-keeping": "Security code of timekeeping api",
                "code-api-time-keeping-detail": "Need a code to identify this fingerprint latch from which timekeeper",
                "time-keeping-url": "Connection link for the timekeeping device with Dogoo Office",
                "time-keeping-url-title": "Download the synchronization tool for the timekeeping device"
            },
            "time-keeping-gps": {
                "setting-gps-header": "Timekeeping by GPS",
                "setting-gps": "Settings to use GPS",
                "setting-gps-detail": "Turn it on when your company uses GPS timekeeping",
                "dot-location-setting-gps": "GPS timekeeping location",
                "dot-location-setting-gps-ref": "Go to settings",
                "setting": "Setting",
                "copy" : "Content copied successfully"
            },
            "api-time-keeping": {
                "api-time-keeping-header": "TIME TIME API",
                "api-time-keeping-setting": "Timekeeping API settings",
                "api-time-keeping-setting-detail": "Allows customers to use keywords in the date table to retrieve employee information: timekeeping, late arrival, early departure..."
            },
            "other-settings": {
                "other-settings-header": "OTHER SETTINGS",
                "line-split": "Separation of timekeeping lines of personnel",
                "line-split-detail": "In 1 month, personnel can be in different departments, positions or salaries. Each such value should be shown on one line. Therefore, the line separation is necessary for the management to have an intuitive view.",
                "line-split-select": {
                    "not-line-split": "No line splitting",
                    "job-line-split": "According to standard work",
                    "position-line-split": "By location, department",
                    "position-salary-line-split": "According to position salary",
                    "subsidies-salary-line-split": "Subsidies salary",
                    "the-labor-contract": "According to the labor contract"
                },
                "rounding-factor": "Rounding factor",
                "rounding-factor-detail": "For example: You set 0.125, then when you do it at 07:01, the system rounds up to 08:00. Usually, companies will not round and will take the actual time.",
                "advance-work-day": "Advance work day",
                "advance-work-day-detail": "There will be companies that end the timekeeping month on the 30th, but the salary has been distributed on the 20th, personnel can completely accept an advance for public employees from the 20th to the 30th to calculate salary.",
                "advance-work-day-form": {
                    "advance-is-allowed": "Advance is allowed",
                    "no-advance-is-allowed": "No advance allowed"
                },
                "single-word-latch": "Single word latch",
                "single-word-latch-detail": "Closing is a business to not allow employees to create orders from that month anymore, in order to avoid errors in the calculation in the time sheet. There are 2 ways to close: Automatically on a fixed monthly basis or you can manually latch on the time sheet.",
                "single-word-form": "Craftsmanship",
                "single-word-form-auto": "Automatic",
                "single-word-latch-auto": "The automatic closing date after the feat is",
                "single-word-latch-auto-detail": "In case you choose to close automatically, please select the date you want to close"
            }
        },
        "compensation-setting": {
            "compensation-header": "Compensation setting",
            "allow-compensation": "Compensatory leave is allowed",
            "allow-compensation-detail": "Although not specified in the law, many businesses apply this form when employees work overtime, instead of paying, they are converted to compensatory leave.",
            "conversionRate": "Conversion rate of overtime and compensatory time off",
            "conversionRate-detail": "For example: If you set the rate to 1.5, it means that 1 hour of overtime will be converted to 1.5 hours of compensatory rest",
            "timeExpire": "Expired time",
            "timeExpireDetail": "The time allowed for compensatory leave is counted from the beginning of the application for overtime and overtime. After this time, the employee is no longer entitled to the compensatory leave of that application.",
            "timeExpireForm": {
                "doesNotExpire": "No Expiration",
                "expiresInMonth": "Expires In Month",
                "1Month": "1 Month",
                "3Month": "3 Month",
                "6Month": "6 Month",
                "12Month": "12 Month"
            },
            "compensatory-leave": "Advance payment for compensatory leave",
            "compensatory-leave-detail": "Similar to leave, if this option is enabled, your business allows employees to advance the compensatory leave fund.",
            "compensatory-leave-maxtime": "The maximum number of compensatory leave hours to be applied",
            "compensatory-leave-maxtime-detail": "For example: If you are given 4 hours in advance, when you make an application for leave, the time should not exceed 4 hours",
            "compensatory-leave-maxtime-form": "Hours"
        },
    }
}
